import { useEffect, useState } from "react";
import { toast } from "react-hot-toast"; // Added for toast notifications
import { useLocation } from "react-router-dom";
import download from "../../assets/download.png";
import email from "../../assets/email.png";
import upload from "../../assets/upload.png";
import ActivateCard from "../../Components/Cards/ActivateCard/ActivateCard";
import DeleteCard from "../../Components/Cards/DeleteCard/DeleteCard";
import Mail from "../../Components/Cards/Mail/Mail";
import UploadMaster from "../../Components/Cards/UploadMaster/UploadMaster";
import Student_Form from "../../Components/Forms/Student/Sudent_Form";
import GeneratePassword from "../../Components/GeneratePassword/GeneratePassword";
import { useSearch } from "../../context/SearchContext"; // Added for search context
import api from "../../utils/api";
import "./Student_Management.css";

const Student_Management = () => {
  const { search } = useSearch();
  const [open, setOpen] = useState("");
  const [data, setData] = useState([]);
  const [display, setDiplay] = useState(0);
  const [activate, setActivate] = useState(false);
  const [isModal, setIsModal] = useState(0);
  const [isUpload, setIsUpload] = useState(false);
  const [id, setId] = useState();
  const [gr, setGr] = useState();
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  // const [searchParams, setSearchParams] = useSearchParams();
  const { state } = useLocation();
  const [status, setStatus] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState({});
  // console.log(searchParams.get("gr"));
  const [display1, setDisplay1] = useState(0);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0,
  });

  const handlePageChange = (newPage) => {
    setPagination((prev) => ({
      ...prev,
      page: newPage,
    }));
  };

  // Fetch all students
  const fetchStudents = async () => {
    await api
      .get(
        `/students?search=${search}&page=${pagination.page}&limit=${pagination.limit}`
      )
      .then((data) => {
        setData(data?.data?.data);
        setPagination(data?.data?.pagination);
      });
  };

  useEffect(() => {
    const fetchData = async () => {
      if (state?.gr) {
        await api
          .get(`/students?gr=%23${state.gr}`)
          .then((response) => response.json())
          .then((data) => {
            setData(data?.data);
          });
      }
      fetchStudents();
    };
    fetchData();
    // eslint-disable-next-line
  }, [state, search, pagination.page, pagination.limit]);

  // Activate all students
  const activateAll = async () => {
    await api
      .get(`/students/activate`)
      .then((response) => response.data)
      .then((data) => {
        fetchStudents();
        setOpen3(false);
        toast.success("All students activated!");
      })
      .catch(() => toast.error("Failed to activate all students!"));
  };

  // Deactivate all students
  const deactivateAll = async () => {
    await api
      .get(`/students/deactivate`)
      .then((response) => response.data)
      .then((data) => {
        fetchStudents();
        setOpen2(false);
        toast.success("All students deactivated!");
      })
      .catch(() => toast.error("Failed to deactivate all students!"));
  };

  // Download master file
  const handleDownload = async () => {
    try {
      const fileName = "students.csv";
      const response = await api.get("/students/download", {
        responseType: "blob",
      });

      if (response.data.size === 0) {
        throw new Error("File not found");
      }

      const fileURL = URL.createObjectURL(response.data);
      const downloadLink = document.createElement("a");
      downloadLink.href = fileURL;
      downloadLink.download = fileName;
      downloadLink.click();
      URL.revokeObjectURL(fileURL);

      toast.success("Master downloaded successfully!");
    } catch (error) {
      toast.error("Error downloading the file!");
      console.error("Error downloading the file:", error);
    }
  };

  // Send master to mail
  const handleSendMasterToMail = async () => {
    try {
      await api.post("/students/send-master-mail");
      toast.success("Master sent to mail successfully!");
    } catch (err) {
      toast.error("Failed to send master to mail!");
    }
  };

  // Handle status change (activate/deactivate)
  const handleStatus = async () => {
    await api.put(`/students/status/${id}`, {
      status: status === "active" ? "inactive" : "active",
    });
    setIsModal(0);
    fetchStudents(); // Refresh data after status change
    toast.success("Status updated!");
  };

  // Handle edit save (call this from Student_Form after edit)
  const handleEditSave = async (updatedData) => {
    try {
      await api.put(`/students/${updatedData.id}`, updatedData);
      toast.success("Student updated successfully!");
      setIsEdit(false);
      setDisplay1(0);
      fetchStudents();
    } catch (err) {
      toast.error("Failed to update student!");
    }
  };

  // Example upload handler for the commented form (if you want to use it)
  // const handleFileUpload = async (e) => {
  //   e.preventDefault();
  //   const file = e.target.file.files[0];
  //   if (!file) {
  //     toast.error("Please select a file to upload.");
  //     return;
  //   }
  //   const formData = new FormData();
  //   formData.append("file", file);
  //   try {
  //     await api.post("/students/upload", formData, {
  //       headers: { "Content-Type": "multipart/form-data" },
  //     });
  //     toast.success("Master uploaded successfully!");
  //     fetchStudents();
  //   } catch (err) {
  //     toast.error("Upload failed!");
  //   }
  // };

  return (
    <div className="student">
      {display ? (
        <GeneratePassword
          setDisp={() => {
            setDiplay(0);
          }}
          id={id}
          gr={gr}
          role="students"
        />
      ) : null}
      {isModal ? (
        <ActivateCard
          action={handleStatus}
          msg="Are you sure you want to change the status of the student ?"
          close={() => {
            setIsModal(0);
          }}
        />
      ) : null}
      {isUpload ? (
        <UploadMaster
          table="students"
          close={() => {
            setIsUpload(false);
          }}
        />
      ) : null}
      {display1 ? (
        <Student_Form
          setDisp={() => {
            setDisplay1(0);
          }}
          onSuccess={() => {
            fetchStudents();
          }}
          data={editData}
          isEdit={isEdit}
          setEdit={() => {
            setIsEdit(false);
          }}
          onSave={handleEditSave} // Pass the new handler to Student_Form
        />
      ) : null}
      <div className="student__top">
        <div className="student__top_button">
          {/* Example upload form (uncomment if you want to use direct file upload)
          <form onSubmit={handleFileUpload}>
            <input type="file" name="file" />
            <input type="submit" value="Upload" />
          </form>
          */}
          <button
            type="button"
            className="student__top_button_button"
            onClick={() => {
              setIsUpload(true);
            }}
          >
            <img
              className="student__top_button_img"
              src={upload}
              alt="upload"
            />
            Upload Master
          </button>
        </div>
        <div className="student__top_button">
          <button
            type="button"
            className="student__top_button_button"
            onClick={handleDownload}
            style={{ width: "200px" }}
          >
            <img
              className="student__top_button_img"
              src={download}
              alt="upload"
            />
            Download Master
          </button>
        </div>
        {/* <div className="student__top_button">
          <button
            type="button"
            className="student__top_button_button"
            onClick={handleSendMasterToMail}
          >
            <img
              className="student__top_button_img"
              src={email}
              alt="mail"
            />
            Send Master to Mail
          </button>
        </div> */}
        <div className="student__top_button">
          <button
            type="button"
            className="student__top_button_button"
            onClick={() => {
              setOpen3(true);
            }}
          >
            Activate All
          </button>
        </div>
        <div className="student__top_button">
          <button
            type="button"
            className="student__top_button_button"
            onClick={() => {
              setOpen2(true);
            }}
          >
            Deactivate All
          </button>
        </div>
      </div>
      <div className="student__middle">
        <table>
          <tr className="student__middle_tr">
            <th className="student__middle_th">GR Number</th>
            <th className="student__middle_th">Name</th>
            <th className="student__middle_th">Father Name</th>
            <th className="student__middle_th">Surname</th>
            <th className="student__middle_th">Gender</th>
            <th className="student__middle_th">Class</th>
            <th className="student__middle_th">Email</th>
            {/* <th className="student__middle_th">Section</th> */}
            <th className="student__middle_th">Section</th>
            <th className="student__middle_th">Mother Name</th>
            <th className="student__middle_th">Mother E-mail</th>
            <th className="student__middle_th">Mother's phone</th>
            <th className="student__middle_th">Father E-mail</th>
            <th className="student__middle_th">Father's phone</th>
            <th className="student__middle_th">Phone</th>
            <th className="student__middle_th">DOB</th>
            <th className="student__middle_th">Date of Admission</th>
            <th className="student__middle_th">Contact</th>
            <th className="student__middle_th"> </th>
            <th className="student__middle_th"> </th>
          </tr>
          {data &&
            data.map((data) => {
              return (
                <tr className="student__middle_tr" key={data.id}>
                  <td className="student__middle_td">{data.gr?.toUpperCase() || "-"}</td>
                  <td className="student__middle_td">{data.name?.toUpperCase() || "-"}</td>
                  <td className="student__middle_td">{data.father_name?.toUpperCase() || "-"}</td>
                  <td className="student__middle_td">{data.surname?.toUpperCase() || "-"}</td>
                  <td className="student__middle_td">{data.gender?.toUpperCase() || "-"}</td>
                  <td className="student__middle_td">{data.class?.toUpperCase() || "-"}</td>
                  <td className="student__middle_td">{data.email?.toUpperCase() || "-"}</td>
                  <td className="student__middle_td">{data.section?.toUpperCase() || "-"}</td>
                  <td className="student__middle_td">{data.mother_name?.toUpperCase() || "-"}</td>
                  <td className="student__middle_td">{data.mother_email?.toUpperCase() || "-"}</td>
                  <td className="student__middle_td">{data.mother_phone?.toUpperCase() || "-"}</td>
                  <td className="student__middle_td">
                    <a href={`mailto:${data.father_email || "-"}`}>
                      {data.father_email?.toUpperCase() || "-"}
                    </a>
                  </td>
                  <td className="student__middle_td">{data.father_phone?.toUpperCase() || "-"}</td>
                  <td className="student__middle_td">{data.phone?.toUpperCase() || "-"}</td>
                  <td className="student__middle_td">
                    {data.dob ? new Date(data.dob).toLocaleDateString("en-CA") : "-"}
                  </td>
                  <td className="student__middle_td">
                    {data.date_of_admission ? new Date(data.date_of_admission).toLocaleDateString("en-CA") : "-"}
                  </td>
                  <td className="student__middle_td">
                    <button
                      type="button"
                      onClick={() => {
                        setOpen(data.id);
                      }}
                      style={{ border: "none", backgroundColor: "transparent" }}
                    >
                      <img src={email} alt="" />
                    </button>
                    {/* <a
                      href={`mailto:${data.mother_email},${data.father_email}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src={email} alt="" />
                    </a> */}
                  </td>
                  <td className="student__middle_td">
                    <div
                      className="student__middle_td_activate"
                      style={
                        data.status === "active"
                          ? { backgroundColor: "#1eae7a" }
                          : { backgroundColor: "#cb444a" }
                      }
                      onClick={() => {
                        setId(data.id);
                        setIsModal(1);
                        setStatus(data.status);
                      }}
                    >
                      <a href="#" style={{ margin: 0 }}>
                        {data.status === "active" ? "Active" : "Deactive"}
                      </a>
                    </div>
                  </td>
                  {/* <td className="student__middle_td">
                    <div
                      className="student__middle_td_generate_password"
                      onClick={() => {
                        setId(data.id);
                        setGr(data.gr);
                        setDiplay(1);
                      }}
                    >
                      <a href="#">Generate Password</a>
                    </div>
                  </td> */}
                  <td>
                    <button
                      type="button"
                      className="circular__middle_td_edit"
                      onClick={() => {
                        setIsEdit(true);
                        setEditData(data);
                        setDisplay1(1);
                      }}
                    >
                      Edit
                    </button>
                  </td>
                </tr>
              );
            })}
        </table>
      </div>
      {open !== "" ? <Mail open={open} close={() => setOpen("")} /> : null}
      {open3 ? (
        <DeleteCard
          btn="Activate All"
          del={activateAll}
          msg="Are you sure you want to activate all students ?"
          close={() => {
            setOpen3(0);
          }}
        />
      ) : null}
      {open2 ? (
        <DeleteCard
          btn="Deactivate All"
          del={deactivateAll}
          msg="Are you sure you want to deactivate all students ?"
          close={() => {
            setOpen2(0);
          }}
        />
      ) : null}
      {/* Pagination Controls */}
      <div
        className="pagination-controls"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          marginTop: "20px",
          gap: "10px",
        }}
      >
        <button
          onClick={() => handlePageChange(pagination.page - 1)}
          disabled={pagination.page === 1}
          style={{
            padding: "5px 10px",
            cursor: pagination.page === 1 ? "not-allowed" : "pointer",
            opacity: pagination.page === 1 ? 0.5 : 1,
          }}
        >
          Previous
        </button>

        <span>
          Page {pagination.page} of {pagination.totalPages}
        </span>

        <button
          onClick={() => handlePageChange(pagination.page + 1)}
          disabled={pagination.page === pagination.totalPages}
          style={{
            padding: "5px 10px",
            cursor:
              pagination.page === pagination.totalPages
                ? "not-allowed"
                : "pointer",
            opacity: pagination.page === pagination.totalPages ? 0.5 : 1,
          }}
        >
          Next
        </button>

        <div style={{ marginLeft: "20px" }}>
          <label htmlFor="limit-select" style={{ marginRight: "10px" }}>
            Items per page:
          </label>
          <select
            value={pagination.limit}
            onChange={(e) => {
              setPagination((prev) => ({
                ...prev,
                limit: Number(e.target.value),
                page: 1,
              }));
            }}
            style={{
              padding: "5px",
              marginLeft: "10px",
                            backgroundColor:"rgb(239,239,239)",

            }}
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default Student_Management;
